import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";

interface NewPageUrlModalFormProps {
  pageUrlValidationSchema: any;
  onCreateNewUrl: (pageUrlDetails: any) => void;
  pageUrlData?: {
    pageURLId: number;
    description: string;
    url: string;
  };
  isEdit: boolean;
  onClose: ()=>void;
}


const NewPageUrlModalForm: React.FC<NewPageUrlModalFormProps> = ({
  pageUrlValidationSchema,
  onCreateNewUrl,
  pageUrlData,
  isEdit,
  onClose,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () =>{ setShowModal(false); onClose()}
  const handleModalOpen = () => setShowModal(true);
  const { pageUrlTypeId } = useParams();

  const formik = useFormik({
    initialValues:  {
      pageURLId: isEdit? pageUrlData?.pageURLId: null,
      description: "",
      url: "",
    },
    validationSchema: pageUrlValidationSchema,
    onSubmit: (values, { resetForm }) => {
      onCreateNewUrl(values);
      resetForm();
      handleModalClose();
    },
  });

  useEffect(() => {
   if(isEdit && pageUrlData){
    formik.setValues({pageURLId: pageUrlData?.pageURLId, description: pageUrlData?.description, url: pageUrlData?.url,})
    handleModalOpen();  
      
    }
  }, [isEdit])
  

  return (
    <>
      {!isEdit && (
        <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
          {"Add Page URL"}
        </Button>
      )}
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Update Page URL" : "Add Page URL"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
          {isEdit && <Form.Group className="mb-3" controlId="pageURLId">
              <Form.Label>Page URL Id</Form.Label>
              <Form.Control
                readOnly
                defaultValue={isEdit ? pageUrlData?.pageURLId : ""}
                type="number"
                name="pageURLId"
                onChange={formik.handleChange}
                isInvalid={
                  !!(formik.touched.pageURLId && formik.errors.pageURLId)
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.pageURLId}
              </Form.Control.Feedback>
            </Form.Group>}
            <Form.Group className="mb-3" controlId="description">
              <Form.Label>Description</Form.Label>
              <Form.Control
                defaultValue={isEdit ? pageUrlData?.description: ''}
                type="text"
                name="description"
                onChange={formik.handleChange}
                isInvalid={!!(formik.touched.description && formik.errors.description)}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.description}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="url">
              <Form.Label>Url</Form.Label>
              <Form.Control
              defaultValue={isEdit ? pageUrlData?.url: ''}
                type="text"
                name="url"
                onChange={formik.handleChange}
                isInvalid={
                  !!(formik.touched.url && formik.errors.url)
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.description}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => formik.handleSubmit()}>
            {isEdit? 'Update': 'Add'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NewPageUrlModalForm;
